import { SampleMaterialEditForm, SampleMaterialEditFormValues } from 'features';
import { Dialog, DialogCloseButton, DialogContent, DialogTitle } from 'ui';

export const SampleMaterialEditDialog = ({
  open,
  onClose,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: SampleMaterialEditFormValues) => void;
}) => (
  <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
    <DialogTitle>Edit Sample material</DialogTitle>
    <DialogCloseButton onClick={onClose} />

    <DialogContent>
      <SampleMaterialEditForm onSubmit={onSubmit} />
    </DialogContent>
  </Dialog>
);
